<div class="capacity_bars" style="user-select: none; max-width: 100%; width: 100%">
  <!-- Werkzeugleiste: Ansicht, Datums-Navigation, Filter -->
  <div class="toolbar">
    <div class="view_toggle">
      <button type="button" [class.active]="view === 'day'" (click)="setView('day')">Tag</button>
      <button type="button" [class.active]="view === 'grid'" (click)="setView('grid')">2 Wochen</button>
    </div>
    <button type="button" class="nav_pill round_btn" (click)="navigateEvent.emit('prev')" aria-label="Zurück">
      <svg class="chevron_svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
    </button>
    <span class="period_label">{{ periodLabel }}</span>
    <button type="button" class="nav_pill round_btn" (click)="navigateEvent.emit('next')" aria-label="Weiter">
      <svg class="chevron_svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
    <button
      type="button"
      class="nav_pill"
      [class.active]="isCurrentPeriod"
      (click)="navigateEvent.emit('today')"
    >
      Heute
    </button>
    @if (filter.length) {
      <div class="toolbar_right" [style.visibility]="view === 'day' ? 'visible' : 'hidden'">
        <button type="button" class="filter_pill" [class.selected]="activeFilter === ''" (click)="activeFilter = ''">
          Alle
        </button>
        @for (f of filter; track f) {
          <button type="button" class="filter_pill" [class.selected]="activeFilter === f" (click)="activeFilter = f">
            {{ f }} ({{ getFilterInstanceAmount(f) }})
          </button>
        }
      </div>
    }
  </div>

  @if (options.length) {
    <button type="button" class="options_toggle" (click)="optionsExpanded = !optionsExpanded">
      <fa-icon [icon]="optionsExpanded ? faChevronUp : faChevronDown"></fa-icon>
      Optionen
    </button>
  }

  <!-- Legende je Ansicht -->
  @if (view === 'day') {
    @if (labels?.length) {
      <div class="legend_row">
        @for (label of labels; track label) {
          <span class="legend_item">
            <i class="legend_square" [style.background-color]="label.color"></i>
            {{ label.description }}
          </span>
        }
      </div>
    }
  } @else {
    <div class="legend_row">
      <span class="legend_item"><i class="legend_square" style="background: #e04b3d"></i>&lt; 50 %</span>
      <span class="legend_item"><i class="legend_square" style="background: #f7cf4d"></i>50–79 %</span>
      <span class="legend_item"><i class="legend_square" style="background: #a8e0a0"></i>80–99 %</span>
      <span class="legend_item"><i class="legend_square" style="background: #2e9e3f"></i>≥ 100 %</span>
      <span class="legend_item"><i class="legend_square legend_square_absent"></i>Abwesenheit</span>
      <span class="legend_hint">U Urlaub · K Krank · F Feiertag · S keine Schicht</span>
    </div>
  }

  <!-- Tagesansicht: Balken-Spalten -->
  @if (view === 'day') {
    <div class="bars_scroll">
      @if (optionsExpanded) {
        <!-- Optionen im selben Scroll-/Rasterlayout wie die Balken, damit
             die Checkboxen exakt über den Spalten bleiben -->
        @for (option of options; track option) {
          <div class="options_block">
            <div class="options_title_row">
              <span class="options_title">{{ option.title }}</span>
              @if (option.tooltip) {
                <fa-icon [icon]="faInfoCircle" [tooltip]="option.tooltip"></fa-icon>
              }
            </div>
            <div class="options_row">
              @for (bar of shownBars; track bar) {
                <div class="options_cell">
                  <mat-checkbox
                    color="primary"
                    [(ngModel)]="bar.data.options[option.title]"
                    (change)="
                      changeOptionEvent.emit({
                        idx: bar.data.external_idx >= 0 ? bar.data.external_idx : bars.indexOf(bar),
                        option: option.title,
                        new_value: $event.checked,
                      })
                    "
                  ></mat-checkbox>
                </div>
              }
            </div>
          </div>
        }
      }
      <div class="bars_layout">
        <div class="hours_axis">
          <div class="axis_badge_spacer"></div>
          <div class="axis_area">
            @for (step of unitAmountSteps; track step) {
              <span class="axis_label" [style.bottom]="step.percentage + '%'">{{ step.description }}</span>
            }
          </div>
        </div>
        <div class="columns_row">
          @for (bar of shownBars; track bar) {
            <div class="bar_column">
              <div
                class="utilization_badge"
                [ngClass]="bar.data.absence_reason ? 'absent' : getUtilizationClass(bar.data.utilizationPercent)"
                [title]="bar.data.absence_reason || ''"
              >
                {{ bar.data.absence_reason ? absenceCode(bar.data.absence_reason) : getUtilizationLabel(bar) }}
              </div>
              <div class="bar_track">
                @for (step of unitAmountSteps; track step) {
                  <i class="gridline" [style.bottom]="step.percentage + '%'"></i>
                }
                @for (segment of bar.segments; track segment) {
                  <div
                    class="segment"
                    [ngClass]="(segment.style || bar.data.style) === 'bordered' ? 'bordered' : 'filled'"
                    [style.bottom]="segment.bottom_percent + '%'"
                    [style.height]="segment.height_percent + '%'"
                    [style.background-color]="(segment.style || bar.data.style) === 'filled' ? segment.color : 'transparent'"
                    [style.border-color]="segment.color"
                    [tooltip]="$any(barTooltipTemplate)"
                    contentType="template"
                    (click)="clickBarEvent.emit(bar.data.external_idx >= 0 ? bar.data.external_idx : bars.indexOf(bar))"
                  >
                    @if (segment.icon) {
                      <fa-icon class="bar_icon" [icon]="segment.icon"></fa-icon>
                    }
                    <ng-template #barTooltipTemplate>
                      @if (segment.tooltip.infos?.length) {
                        <div style="text-align: left">
                          <h6>Info</h6>
                          <ul>
                            @for (info of segment.tooltip.infos; track info) {
                              <li>
                                {{ info }}
                              </li>
                            }
                          </ul>
                        </div>
                      }
                      @if (segment.tooltip.errors?.length) {
                        <div style="text-align: left">
                          <h6>Fehler</h6>
                          <ul>
                            @for (error of segment.tooltip.errors; track error) {
                              <li>
                                {{ error }}
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    </ng-template>
                  </div>
                }
              </div>
            <div class="bar_name">
              <span
                [style.font-size.px]="getNameFontPx(bar.description)"
                [title]="bar.description"
              >{{ bar.description }}</span>
            </div>
            </div>
          }

          @for (deadline of deadlines; track deadline) {
            <div
              class="deadline_line"
              [style.bottom]="getDeadlinePercentage(deadline) + '%'"
              [style.border-color]="deadline.color"
              [title]="deadline.description"
            ></div>
          }

          @if (!shownBars.length) {
            <div class="empty_hint">Keine Techniker für diese Auswahl.</div>
          }
        </div>
      </div>
    </div>
  } @else {
    <!-- 2-Wochen-Ansicht: Grid-Tabelle -->
    <div class="grid_wrap">
      <table class="grid_table">
        <tbody>
          @for (row of grid.rows; track $index) {
            @if (row.kind === 'kw') {
              <tr class="kw_row">
                <td class="kw_label" [attr.colspan]="grid.techs.length + 2">{{ row.label }}</td>
              </tr>
            } @else {
              <tr class="day_row">
                <td class="day_label" [class.today]="row.is_today">{{ row.label }}</td>
                @for (cell of row.cells; track $index) {
                  <td
                    class="grid_cell"
                    [class.absent]="cell.absence"
                    [title]="cell.title"
                    [style.background]="cell.bg"
                    [style.color]="cell.fg"
                  >
                    {{ cell.label }}
                  </td>
                }
                <td class="avg_cell">
                  <div class="avg_pill" [style.background]="row.avg.bg" [style.color]="row.avg.fg" [title]="row.avg.title">
                    {{ row.avg.label }}
                  </div>
                </td>
              </tr>
            }
          }
          <tr class="footer_row">
            <td class="day_label footer_label">Ø 2 Wochen</td>
            @for (cell of grid.footer; track $index) {
              <td class="avg_cell">
                <div class="avg_pill" [style.background]="cell.bg" [style.color]="cell.fg" [title]="cell.title">
                  {{ cell.label }}
                </div>
              </td>
            }
            <td class="avg_cell">
              <div class="avg_pill" [style.background]="grid.team.bg" [style.color]="grid.team.fg" [title]="grid.team.title">
                {{ grid.team.label }}
              </div>
            </td>
          </tr>
          <tr class="tech_names_row">
            <td class="tech_names_label">Techniker</td>
            @for (name of grid.techs; track name) {
              <td class="tech_name">
                <span [style.font-size.px]="getNameFontPx(name, gridNameHeightPx)" [title]="name">{{ name }}</span>
              </td>
            }
            <td class="tech_name team_name"><span>Team</span></td>
          </tr>
        </tbody>
      </table>
      @if (!grid.techs.length) {
        <div class="empty_hint">Keine Techniker für diese Auswahl.</div>
      }
    </div>
  }
</div>
